import React, { Component } from 'react';
import SideNavbar from '../../navbars/SideNavbar';
import NavbarOne from '../../navbars/NavbarOne';
import Footer from '../../footer/Footer';
import { Row, Col, Container, Card, ProgressBar, Accordion, Table } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import './_managequestionpaper.scss';

const FETCH_ADAPTIVE_EXAMS_STUDENT = gql`
  query($exam_id: Int!) {
    getAdaptiveExamsForAStudent(exam_id: $exam_id) {
      correct
      wrong
      not_answered
      total_questions
      score
      accuracy
      exam_paper_id
      exam_name
      exam_id
      mobile
      class
      attempts {
        correct
        wrong
        not_answered
        exams
        avg_score
        avg_accuracy
      }
      subject_stats {
        subject_id
        subject
        attempted
        correct_count
        wrong_count
        not_answered
        correct_percentage
        error_percentage
      }
      chapter_stats {
        chapter_id
        chapter
        subject_id
        subject
        attempted
        correct_count
        wrong_count
        not_answered
        correct_percentage
        error_percentage
      }
      topic_stats {
        topic_id
        topic
        chapter_id
        chapter
        subject_id
        subject
        attempted
        correct_count
        wrong_count
        not_answered
        correct_percentage
        error_percentage
      }
    }
  }
`;

class AdaptiveExamAccessStudents extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  // Group chapter_stats by subject_id for accordion sections
  groupChaptersBySubject = (chapterStats) => {
    const grouped = {};
    (chapterStats || []).forEach(ch => {
      const key = ch.subject_id;
      if (!grouped[key]) grouped[key] = { subject_id: ch.subject_id, subject: ch.subject, chapters: [] };
      grouped[key].chapters.push(ch);
    });
    return Object.values(grouped);
  };

  // Get topics belonging to a specific chapter
  getTopicsForChapter = (topicStats, chapterId) => {
    return (topicStats || []).filter(t => t.chapter_id === chapterId);
  };

  render() {
    const adaptiveExamStudentData = this.props.getAdaptiveExamsForAStudent;
    const loading1 = adaptiveExamStudentData.loading;
    const error1 = adaptiveExamStudentData.error;

    const studentData = adaptiveExamStudentData?.getAdaptiveExamsForAStudent || {};
    const subjectStats = studentData?.subject_stats || [];
    const chapterStats = studentData?.chapter_stats || [];
    const topicStats = studentData?.topic_stats || [];
    const attempts = studentData?.attempts || {};
    const groupedChapters = this.groupChaptersBySubject(chapterStats);

    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    if (Cookies.get("token") == undefined) this.props.history.push("/login");

    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div id="sidebar" className={isBrowser === true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
            <div className="content-wrapper mb-2" style={{ minHeight: "50vh" }}>
              <Container fluid>
                {loading1 ? (
                  <Container>
                    <Row className="my-3">
                      <Col><div className="spinner-border text-primary text-center loading-img-center"></div></Col>
                    </Row>
                  </Container>
                ) : adaptiveExamStudentData?.getAdaptiveExamsForAStudent !== null ? (
                  <>
                    {/* ─── Exam Info Header ─── */}
                    <Card className="border-0 shadow-sm mb-3">
                      <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                        <Card.Title className="mb-0">{studentData?.exam_name || "Exam Report"}</Card.Title>
                        <div>
                          <span className="mr-3 text-muted">Class: <strong>{studentData?.class || "-"}</strong></span>
                          <span className="text-muted">Mobile: <strong>{studentData?.mobile || "-"}</strong></span>
                        </div>
                      </Card.Header>
                    </Card>

                    {/* ─── Overview Stats Table ─── */}
                    <Card className="border-0 shadow-sm mb-3">
                      <Card.Header className="bg-white">
                        <Card.Title className="mb-0">Overview</Card.Title>
                      </Card.Header>
                      <Card.Body className="p-0">
                        <Table bordered size="sm" className="mb-0">
                          <thead>
                            <tr className="bg-light">
                              <th className="text-center">Correct</th>
                              <th className="text-center">Wrong</th>
                              <th className="text-center">Not Answered</th>
                              <th className="text-center">Total Questions</th>
                              <th className="text-center">Score</th>
                              <th className="text-center">Accuracy</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="text-center">{studentData?.correct ?? 0}</td>
                              <td className="text-center">{studentData?.wrong ?? 0}</td>
                              <td className="text-center">{studentData?.not_answered ?? 0}</td>
                              <td className="text-center">{studentData?.total_questions ?? 0}</td>
                              <td className="text-center">{studentData?.score ?? 0}</td>
                              <td className="text-center">{studentData?.accuracy ?? 0}%</td>
                            </tr>
                          </tbody>
                        </Table>
                      </Card.Body>
                    </Card>

                    {/* ─── Subject Performance ─── */}
                    {subjectStats.length > 0 && (
                      <Card className="border-0 shadow-sm mb-3">
                        <Card.Header className="bg-white">
                          <Card.Title className="mb-0">Subject Performance</Card.Title>
                        </Card.Header>
                        <Card.Body className="p-0">
                          <Table bordered size="sm" className="mb-0">
                            <thead>
                              <tr className="bg-light">
                                <th>Subject</th>
                                <th className="text-center">Attempted</th>
                                <th className="text-center">Correct</th>
                                <th className="text-center">Wrong</th>
                                <th className="text-center">Not Answered</th>
                                <th className="text-center">Accuracy</th>
                                <th style={{ width: '150px' }}>Progress</th>
                              </tr>
                            </thead>
                            <tbody>
                              {subjectStats.map((subj, idx) => (
                                <tr key={subj.subject_id || idx}>
                                  <td className="font-weight-bold">{subj.subject}</td>
                                  <td className="text-center">{subj.attempted ?? 0}</td>
                                  <td className="text-center">{subj.correct_count ?? 0}</td>
                                  <td className="text-center">{subj.wrong_count ?? 0}</td>
                                  <td className="text-center">{subj.not_answered ?? 0}</td>
                                  <td className="text-center">{subj.correct_percentage ?? 0}%</td>
                                  <td>
                                    <ProgressBar style={{ height: '8px' }}>
                                      <ProgressBar variant="success" now={subj.correct_percentage || 0} key={1} />
                                      <ProgressBar variant="danger" now={subj.error_percentage || 0} key={2} />
                                    </ProgressBar>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Card.Body>
                      </Card>
                    )}

                    {/* ─── Chapter & Topic Breakdown ─── */}
                    {groupedChapters.length > 0 && (
                      <Card className="border-0 shadow-sm mb-3">
                        <Card.Header className="bg-white">
                          <Card.Title className="mb-0">Chapter & Topic Breakdown</Card.Title>
                        </Card.Header>
                        <Card.Body className="p-0">
                          <Accordion defaultActiveKey="0">
                            {groupedChapters.map((subjectGroup, sIdx) => (
                              <Card className="border-0 border-bottom" key={subjectGroup.subject_id}>
                                <Accordion.Toggle as={Card.Header} eventKey={String(sIdx)} className="bg-light" style={{ cursor: 'pointer' }}>
                                  <strong>{subjectGroup.subject}</strong>
                                  <span className="text-muted ml-2">({subjectGroup.chapters.length} chapters)</span>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={String(sIdx)}>
                                  <Card.Body className="p-0">
                                    <Table bordered size="sm" className="mb-0">
                                      <thead>
                                        <tr className="bg-light">
                                          <th className="pl-3">Chapter / Topic</th>
                                          <th className="text-center">Attempted</th>
                                          <th className="text-center">Correct</th>
                                          <th className="text-center">Wrong</th>
                                          <th className="text-center">Not Answered</th>
                                          <th className="text-center">Accuracy</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {subjectGroup.chapters.map((ch) => {
                                          const chTopics = this.getTopicsForChapter(topicStats, ch.chapter_id);
                                          return (
                                            <React.Fragment key={ch.chapter_id}>
                                              {/* Chapter Row */}
                                              <tr>
                                                <td className="pl-3 font-weight-bold">{ch.chapter}</td>
                                                <td className="text-center">{ch.attempted ?? 0}</td>
                                                <td className="text-center">{ch.correct_count ?? 0}</td>
                                                <td className="text-center">{ch.wrong_count ?? 0}</td>
                                                <td className="text-center">{ch.not_answered ?? 0}</td>
                                                <td className="text-center font-weight-bold">{ch.correct_percentage ?? 0}%</td>
                                              </tr>
                                              {/* Topic Rows */}
                                              {chTopics.map((tp) => (
                                                <tr key={tp.topic_id} className="text-muted">
                                                  <td style={{ paddingLeft: '30px' }}>- {tp.topic}</td>
                                                  <td className="text-center">{tp.attempted ?? 0}</td>
                                                  <td className="text-center">{tp.correct_count ?? 0}</td>
                                                  <td className="text-center">{tp.wrong_count ?? 0}</td>
                                                  <td className="text-center">{tp.not_answered ?? 0}</td>
                                                  <td className="text-center">{tp.correct_percentage ?? 0}%</td>
                                                </tr>
                                              ))}
                                            </React.Fragment>
                                          );
                                        })}
                                      </tbody>
                                    </Table>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </Card>
                            ))}
                          </Accordion>
                        </Card.Body>
                      </Card>
                    )}
                  </>
                ) : (
                  <div className="d-flex justify-content-center py-5">
                    <h6>No Data Found</h6>
                  </div>
                )}
              </Container>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(
  compose(
    graphql(FETCH_ADAPTIVE_EXAMS_STUDENT, {
      options: (props) => ({
        variables: {
          exam_id: parseInt(props.location?.state?.exam_paper_id) || parseInt(props.location?.state?.exam_id) || 0
        },
        fetchPolicy: "network-only"
      }),
      skip: (props) => !props.location?.state?.exam_paper_id && !props.location?.state?.exam_id,
      name: "getAdaptiveExamsForAStudent"
    })
  )(AdaptiveExamAccessStudents)
);